var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 8.94273L12.1953 13.138L13.1381 12.1952L8.94285 7.99992L13.1381 3.80469L12.1953 2.86188L8.00004 7.05711L3.80475 2.86182L2.86194 3.80463L7.05723 7.99992L2.86194 12.1952L3.80475 13.138L8.00004 8.94273Z",
    fill: "#767676"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "assets/9575c90b.svg";